import { render, staticRenderFns } from "./menu3060_1.vue?vue&type=template&id=ae84b0ec&scoped=true&"
import script from "./menu3060_1.vue?vue&type=script&lang=js&"
export * from "./menu3060_1.vue?vue&type=script&lang=js&"
import style0 from "./menu3060_1.vue?vue&type=style&index=0&id=ae84b0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae84b0ec",
  null
  
)

export default component.exports